import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Hidden,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LoadingComponent from "../LoadingComponent/LoadingComponent";

const ArchDialogWZKR = ({ dialog, setDialog, datenWZKR, setDatenWZKR, isLoading }) => {
  const { t } = useTranslation();

  const renderOrig = () => {
    return (
      <>
        <Grid item xs={12} sm={5}>
          <Card>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" colSpan={3}>
                      {t("Originalzeiten")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datenWZKR?.zeitdaten?.map((rows, tcount) => (
                    <TableRow>
                      <TableCell align="center">{rows.von}</TableCell>
                      <TableCell align="center">{"-"}</TableCell>
                      <TableCell align="center">{rows.bis}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
        <Grid item xs={12} sm={5}>
          <Card>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center" colSpan={3}>
                      {t("Antragszeiten")}
                    </TableCell>
                    <TableCell align="center"> {t("Zeitart")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datenWZKR?.zeitdatenantrag?.map((rows) => (
                    <TableRow>
                      <TableCell align="center">{rows.von}</TableCell>
                      <TableCell align="center">{"-"}</TableCell>
                      <TableCell align="center">{rows.bis}</TableCell>
                      {/* <TableCell align="center">{rows.zeitart}</TableCell> */}
                      {datenWZKR?.zeitarten && datenWZKR?.zeitarten.length > 0 && (
                        <TableCell align="center">
                          {datenWZKR?.zeitarten[datenWZKR?.zeitarten?.findIndex((e) => Number(e.key) === Number(rows.zeitart))]?.bez}
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </Grid>
      </>
    );
  };

  const closeDialog = () => {
    setDialog(false);
    setDatenWZKR({});
  };

  return (
    <ResponsiveDialog
      title={t("Details des Korrekturantrags")}
      open={dialog}
      setOpen={() => {
        setDialog(false);
      }}
    >
      {isLoading && <LoadingComponent />}

      {!isLoading && (
        <Box p={1}>
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Grid container justifyContent="center" spacing={2}>
                <Grid item xs={12} sm={10}>
                  <Card>
                    <CardContent>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" align="left">
                            {t("Antragsteller")}
                          </Typography>
                          <Typography align="left">{datenWZKR?.von}</Typography>
                        </Grid>
                        <Hidden smUp>
                          <Grid item xs={12}>
                            <Divider></Divider>
                          </Grid>
                        </Hidden>
                        <Grid item xs={12} sm={6}>
                          <Typography variant="body2" align="left">
                            {t("Antragszeitraum")}
                          </Typography>
                          <Typography align="left">{datenWZKR?.gestellt}</Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                {renderOrig()}
                <Grid item xs={12} sm={10}>
                  <Card>
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="center">{t("Beantragt")}</TableCell>
                            <TableCell align="center">{datenWZKR?.status == "1" ? t("Genehmigt") : t("Abgelehnt")}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell align="center">{"Erweiterter Arbeitszeitrahmen"}</TableCell>
                            <TableCell align="center">{datenWZKR?.regelung_korr}</TableCell>
                            <TableCell align="center">{datenWZKR?.regelung_korrVG}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">{"Abweichende Pause"}</TableCell>
                            <TableCell align="center">{datenWZKR?.pause_korr}</TableCell>
                            <TableCell align="center">{datenWZKR?.pause_korrVG}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">{"Abweichender Pausenwert"}</TableCell>
                            <TableCell align="center">{datenWZKR?.pause_wert}</TableCell>
                            <TableCell align="center">{datenWZKR?.pause_wertVG}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">{"Kappung freigegeben"}</TableCell>
                            <TableCell align="center">{datenWZKR?.kappung}</TableCell>
                            <TableCell align="center">{datenWZKR?.kappungVG}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">{"Vergütungsart"}</TableCell>
                            <TableCell align="center">{datenWZKR?.korr_auswahl?.find((eintrag) => eintrag.key === datenWZKR?.korr)?.bez}</TableCell>
                            <TableCell align="center">{datenWZKR?.korr_auswahl?.find((eintrag) => eintrag.key === datenWZKR?.korrVG)?.bez}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell align="center">{"Bemerkung"}</TableCell>
                            <TableCell align="center">{datenWZKR?.hinwan}</TableCell>
                            <TableCell align="center">{datenWZKR?.hinwanVG}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Button color="primary" variant="outlined" fullWidth onClick={() => closeDialog()}>
                    {t("Fertig")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )}
    </ResponsiveDialog>
  );
};
export default ArchDialogWZKR;
